import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';

@Component({
  standalone: true,
  selector: 'ain-planned-module-placeholder',
  imports: [AinPageComponent, AinStateComponent],
  template: `
    <ain-page [title]="title()" [description]="description()">
      <ain-state
        type="empty"
        [title]="t('nav.placeholder.comingSoon')"
        [message]="t('nav.placeholder.message')" />
      @if (roadmapKey()) {
        <p class="roadmap">{{ t(roadmapKey()!) }}</p>
      }
    </ain-page>
  `,
  styles: [`
    .roadmap { margin-top: 16px; padding: 12px 16px; background: #f8fafc; border-radius: 8px; color: #475569; font-size: 14px; line-height: 1.5; }
  `]
})
export class PlannedModulePlaceholderComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly localization = inject(LocalizationService);

  title(): string {
    const titleKey = (this.route.snapshot.data['plannedTitleKey'] ?? this.route.snapshot.data['titleKey']) as string | undefined;
    return titleKey ? this.t(titleKey) : this.t('nav.placeholder.title');
  }

  description(): string {
    const key = this.route.snapshot.data['plannedDescriptionKey'] as string | undefined;
    return key ? this.t(key) : this.t('nav.placeholder.description');
  }

  roadmapKey(): string | null {
    return (this.route.snapshot.data['plannedRoadmapKey'] as string | undefined) ?? null;
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
